import { useQuery } from '@apollo/client';

import useCurrentLanguage from 'common/hooks/useCurrentLanguage';

import { InternationalTransferCurrenciesDocument } from './internationalTransferCurrencies.gql';

export const useInternationalTransferCurrencies = () => {
  const language = useCurrentLanguage();
  const { data, ...hook } = useQuery(InternationalTransferCurrenciesDocument, {
    variables: { lang: language },
  });

  return {
    internationalTransferCurrencies: data?.internationalTransferCurrencies,
    ...hook,
  };
};
